export const getTotalPages = (totalCount: number, pageSize: number) => {
  if (pageSize <= 0) return 0;

  return Math.ceil(Math.max(0, totalCount) / pageSize);
};
